module.exports = __webpack_public_path__ + "img/L_323_327.97c6f754.png";